
function refreshSlider(){
new Swiper(".ACC_JackiesKids_CartDrawer_35-swiper.swiper", {
slidesPerView: 1,
loop: true,
pagination: {
el: ".ACC_JackiesKids_CartDrawer_35-swiper_pagination",
clickable: true,
},
navigation: {
nextEl: ".ACC_JackiesKids_CartDrawer_35-swiper_button_next",
prevEl: ".ACC_JackiesKids_CartDrawer_35-swiper_button_prev"
},
});
}

function handleResponse() {
let html = JSON.parse(this.responseText);

document.querySelector("div#shopify-section-cart-drawer").outerHTML=html['cart-drawer'];
document.querySelector("cart-drawer").classList.add("active");
document.querySelector("cart-drawer").classList.remove("is-empty")
refreshSlider()
}

document.addEventListener("DOMContentLoaded", function() {
// Use event delegation to attach the event listener to the entire document
$(document).on('click', function(evt) {
// Check if the clicked element is one of the dynamically added .add-wrapper-upsell elements
if ($(evt.target).closest(".add-wrapper-upsell, .add-wrapper-upsell svg").length) {
evt.preventDefault();
let key = $(evt.target).closest("[data-line]").data("line");
const popup = $(`.ACC_JackiesKids_CartDrawer_26_wrapper_popup[data-popup-key="${key}"]`);
if (popup.length) {
popup.toggleClass("ACC_JackiesKids_CartDrawer_26_wrapper_popup_hide");
}
}
});



});

document.addEventListener("DOMContentLoaded", function() {
// Use event delegation to handle clicks on variants
document.addEventListener("click", function(evt) {
// Check if the clicked element is one of the variants (class .ACC_JackiesKids_CartDrawer_26_col_variant)
if (evt.target && evt.target.closest(".ACC_JackiesKids_CartDrawer_26_col_variant")) {
// Find the clicked variant
const clickedVariant = evt.target.closest(".ACC_JackiesKids_CartDrawer_26_col_variant");

// Find all variants in the same container
const allVariants = clickedVariant.closest(".ACC_JackiesKids_CartDrawer_26_wrapper_popup_subheading_variant")
.querySelectorAll(".ACC_JackiesKids_CartDrawer_26_col_variant");

// Remove the active class from all variants
allVariants.forEach(function(variant) {
variant.classList.remove("ACC_JackiesKids_CartDrawer_26_col_variant_active");
});

// Add the active class to the clicked variant
clickedVariant.classList.add("ACC_JackiesKids_CartDrawer_26_col_variant_active");
}
});

$("body").on("click",".ACC_JackiesKids_CartDrawer_26_wrapper_popup_close", function() {
$(".ACC_JackiesKids_CartDrawer_26_wrapper_popup").addClass("ACC_JackiesKids_CartDrawer_26_wrapper_popup_hide");
});




$("body").on("click",".add-wrapper-upsell-img-close",async function(){
$("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
$("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
$("div#CartDrawer-Overlay").addClass("disabledCheckout");
let id = $(this).attr("data-quantity-variant-id");
let n =$(`.quantity__input[data-quantity-variant-id=${id}]`).val();
let deletegiftn = $(this).attr("data-n");
n=parseInt(n)- parseInt(deletegiftn);
let key = $(this).attr("data-key");
let mainquan = $(this).attr("data-n");
var formData = new FormData();
formData.append("updates["+id+"]", n);

await fetch(window.Shopify.routes.root + 'cart/update.js', {
method: 'POST',
body: formData
})
.then(response => response.json())
.then(async (data)=>{

let updates = {
"id": key,
'properties': { 'Cover': "" },
'quantity': mainquan
};

await fetch(window.Shopify.routes.root + 'cart/change.js?gift=true', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(updates)
})
.then(response => {
return response.json();
}).then((res)=>{
const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', '/?sections=cart-drawer', true);
request.send();
function handleResponse() {
let html = JSON.parse(this.responseText);
document.querySelector("div#shopify-section-cart-drawer").outerHTML=html['cart-drawer'];
document.querySelector("cart-drawer").classList.add("active")
} 
})
.catch((error) => {
console.error('Error:', error);
}); 

});
});

});


document.addEventListener("DOMContentLoaded", function() {


refreshSlider();

$("body").on("click",".ACC_JackiesKids_CartDrawer_26_wrapper_popup_atc_section_btn",async function(e) {
e.preventDefault();
let id = $(this).parent().prev().find(".ACC_JackiesKids_CartDrawer_26_col_variant.ACC_JackiesKids_CartDrawer_26_col_variant_active").attr("data-quantity-variant-id");
let title = $(this).parent().prev().find(".ACC_JackiesKids_CartDrawer_26_col_variant.ACC_JackiesKids_CartDrawer_26_col_variant_active").attr("data-title");
let n = $(this).attr('data-quantity');
let mainid = this.getAttribute('data-atc-id');

$("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
$("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
$("div#CartDrawer-Overlay").addClass("disabledCheckout");

let formData = {
'items': [{
'id': id,
'quantity': n
}]
};

await fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then(response => {
return response.json();
}).then(async (res)=>{
if(res.items.length > 0)
{

let updates = {
"id": mainid,
'properties': { 'Cover': title },
'quantity': n
};

await fetch(window.Shopify.routes.root + 'cart/change.js?gift=true', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(updates)
})
.then(response => {
return response.json();
}).then((res)=>{
const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', '/?sections=cart-drawer', true);
request.send(); 
})
.catch((error) => {
console.error('Error:', error);
});    

}
})
.catch((error) => {
console.error('Error:', error);
});
});

});

function refreshCart(){
let updates = {};
$(".cart-item--product-gift-wrapping").each(function(){

let title = $(this).attr("data-title");
if(title == 'christmas')
{
let id =  $(this).attr("data-id");
let chris = $("button#CartDrawer-Checkout").attr("data-christmas") || 0;
updates[id]=chris;
}
else
{
let id =  $(this).attr("data-id");
let silver = $("button#CartDrawer-Checkout").attr("data-silver") || 0;

updates[id]=silver;
}
});

fetch(window.Shopify.routes.root + 'cart/update.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify({ updates })
})
.then(response => {
return response.json();
}).then((res)=>{
const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', '/?sections=cart-drawer', true);
request.send();

})
.catch((error) => {
console.error('Error:', error);
});
}


let debounceTimeout;

function debounceRefreshCart() {
clearTimeout(debounceTimeout);
$("button#CartDrawer-Checkout").addClass("disabledCheckout").find("span.button__label").remove();
$("button#CartDrawer-Checkout").find("span.loading-overlay").removeClass("hidden");
$("div#CartDrawer-Overlay").addClass("disabledCheckout");
debounceTimeout = setTimeout(refreshCart, 1100); 
}

function openCart()
{
 const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', '/?sections=cart-drawer', true);
request.send(); 
}
new PerformanceObserver(function(e) {
!e.getEntriesByType("resource").some(({name})=>/\/cart\/change(?=\s|$)/i.test(name)) || debounceRefreshCart()
}).observe({entryTypes: ["resource"]});


new PerformanceObserver(function(e) {
!e.getEntriesByType("resource").some(({name})=>/\/cart\/(change|update|clear)/i.test(name)) || refreshSlider()
}).observe({entryTypes: ["resource"]});


new PerformanceObserver(function(e) {
!e.getEntriesByType("resource").some(({name})=>/\/cart\/(add)/i.test(name)) || openCart()
}).observe({entryTypes: ["resource"]});

